import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import '@mdi/font/css/materialdesignicons.css'

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
          light: {
            cardbackground: '#F8F8F8',
            tertiary: '#5295c4',
            accent: '#E67900',
            secondary: '#c45e52',
            success: '#12A680',
            primary: '#334D5C',
            info: '#5295c4',
            warning: '#DBA617',
            error: '#dc2c2c'
          },
          dark: {
            cardbackground: '#2F2F2F',
            tertiary: '#5295c4',
            accent: '#E67900',
            primary: '#334D5C',
            success: '#12A680',
            secondary: '#c45e52',
            info: '#5295c4',
            warning: '#DBA617',
            error: '#dc2c2c'
          }
        }
      }
});
